import { swNumberFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { RightAlignedCell } from "./RankCell";

export const PagesPerVisit: FC<Pick<ITableCellProps, "value">> = ({ value }) => {
    return (
        <RightAlignedCell>
            <span className="value">{swNumberFilter()(value || 0, 2)}</span>
        </RightAlignedCell>
    );
};
PagesPerVisit.displayName = "PagesPerVisit";
